import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-新闻",
  "use": "icon-新闻-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-新闻\"><path d=\"M928 224h-57.6v646.4H601.6c0 38.4 25.6 70.4 57.6 70.4h268.8c32 0 57.6-32 57.6-70.4v-576c0-38.4-25.6-70.4-57.6-70.4z m0 0\" p-id=\"7956\" fill=\"#5af\" /><path d=\"M768 76.8H166.4c-32 0-57.6 32-57.6 70.4v723.2c0 38.4 25.6 70.4 57.6 70.4H768c32 0 57.6-32 57.6-70.4V153.6c-6.4-44.8-32-76.8-57.6-76.8zM224 262.4h217.6v217.6H224V262.4z m435.2 499.2H224v-70.4h435.2v70.4z m0-140.8H224V550.4h435.2v70.4z m0-147.2H492.8V403.2h160l6.4 70.4z m0-140.8H492.8V262.4h160l6.4 70.4z m0 0\" p-id=\"7957\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/新闻.svg
// module id = sfo5
// module chunks = 250